import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import { LOGALTY_EVENT_CODES } from '../../../../../constants/logalty';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { LOGALTY_CONTRACT_START_PATH } from 'constants/uTagConstants/paths';

import './LogaltyError.scss';

const LogaltyError = ({ errorCode = 'genericError', guid = null, onClick }) => {
    const errorCodes = {
        [LOGALTY_EVENT_CODES.PIN_KO]: 'pinKO',
        [LOGALTY_EVENT_CODES.SESSION_EXPIRED]: 'sessionExpired',
        [LOGALTY_EVENT_CODES.GENERIC_ERROR]: 'genericError',
    };

    useEffect(() => {
        recordEventCustomOnly({
            action: 'open',
            format: 'message',
            component: `message/error/${errorCodes[errorCode]}`,
            element: 'full',
            eventLabel: 'view',
            eventAction: `errorMessage${errorCodes[errorCode]}`,
            eventCategory: LOGALTY_CONTRACT_START_PATH,
        });
    }, []);

    const errors = {
        [LOGALTY_EVENT_CODES.PIN_KO]: {
            title: formatText('signingPage-logaltyPinKoErrorTitle'),
            subtitle: formatText('signingPage-logaltyPinKoErrorSubtitle'),
            buttonLabel: formatText('signingPage-logaltyPinKoErrorBtnLabel'),
        },
        [LOGALTY_EVENT_CODES.SESSION_EXPIRED]: {
            title: formatText('signingPage-logaltySessionKoErrorTitle'),
            subtitle: formatText('signingPage-logaltySessionKoErrorSubtitle'),
            buttonLabel: formatText('signingPage-logaltySessionKoErrorBtnLabel'),
        },
        [LOGALTY_EVENT_CODES.GENERIC_ERROR]: {
            title: formatText('signingPage-logaltyGenericErrorTitle'),
            subtitle: formatText('signingPage-logaltyGenericErrorSubtitle'),
            buttonLabel: formatText('signingPage-logaltyGenericErrorBtnLabel'),
        },
    };

    const handleOnClick = () => {
        recordEventCustomOnly({
            action: 'click',
            format: 'button',
            component: 'contractSignature',
            element: 'end',
            categoriaEvento: LOGALTY_CONTRACT_START_PATH,
            accionEvento: 'clickButton',
            etiquetaEvento: 'endButton',
        });

        onClick();
    };

    return (
        <div className="logalty-error">
            <div className="logalty-error__alert_box">
                <i className="icons icons--icon-close-red" />
                <div className="logalty-error__content">
                    <h3 className="title">{errors[errorCode].title}</h3>
                    <p className="subtitle">{errors[errorCode].subtitle}</p>

                    {guid && <h3 className="guid">GUID: {guid}</h3>}
                </div>
            </div>

            <button className="logalty-error__end_button" onClick={handleOnClick}>
                {errors[errorCode].buttonLabel}
            </button>
        </div>
    );
};

LogaltyError.propTypes = {
    errorCode: PropTypes.string,
};

export default LogaltyError;
